import { PositionBadge } from "./PositionBadge";
import { ActionChip } from "./ActionChip";
import { fmtChips, actionAmount, actionStackAfter, displayChips } from "./helpers";

/**
 * DetailOpRow — fila de acción nativa.
 */

function actionAmountWithFactor(action, factor) {
  return displayChips(actionAmount(action), factor);
}

function actionStackAfterWithFactor(action, factor) {
  return displayChips(actionStackAfter(action), factor);
}

export function DetailOpRow({ action, playerByUid, chipFactor = 1, rowIndex = 0, matchedUidSet }) {
  const uid = action.uid ?? action.user_id ?? action.uid_seat;
  const player = playerByUid?.[uid] || {};
  const nick = action.nick || action.name || player.nick || (uid ? `uid:${uid}` : "—");
  const position = action.position ?? player.position;

  const amount = actionAmountWithFactor(action, chipFactor);
  const stackAfter = actionStackAfterWithFactor(action, chipFactor);
  const showAmount = amount != null && Number(amount) !== 0;
  // Una sola tonalidad oscura para todas las filas (sin zebra striping).
  // Antes alternaba entre #151723 y #11131d.
  const rowBg = "bg-[#11131d]";

  return (
    <div
      className={`grid items-center gap-2 pl-2 pr-3 py-[7px] transition-colors hover:bg-[#202535] ${rowBg}`}
      style={{ gridTemplateColumns: "42px 130px 26px 60px 1fr" }}
      data-testid={`detail-op-row-${uid ?? "x"}`}
    >
      <PositionBadge position={position} />
      <span className="min-w-0 truncate text-[20px] font-extrabold leading-none text-[#f4f4f7] drop-shadow-[0_1px_1px_rgba(0,0,0,0.65)] flex items-center gap-1">
        <span className="truncate">{nick}</span>
        {matchedUidSet?.has(Number(uid)) && (
          <span
            className="text-amber-400 text-[14px] leading-none flex-shrink-0"
            title="UID en MATCH (collusion_suspected)"
            data-testid={`match-stars-action-${uid}`}
          >⭐⭐</span>
        )}
      </span>
      <ActionChip action={action} />
      <span className="text-[18px] font-extrabold tabular-nums leading-none text-[#f4f4f7] text-left drop-shadow-[0_1px_1px_rgba(0,0,0,0.65)]">
        {showAmount ? fmtChips(amount) : ""}
      </span>
      <span
        className="text-[18px] font-extrabold tabular-nums leading-none text-[#f4f4f7] text-right drop-shadow-[0_1px_1px_rgba(0,0,0,0.65)]"
      >
        {stackAfter != null ? fmtChips(stackAfter) : ""}
      </span>
    </div>
  );
}
